import {pulseUserAtom} from 'atoms/auth';
import {growthbookCacheAtom} from 'atoms/growthbook';
import {isFinanceAdmin} from 'helpers/utils';
import {useAtomValue} from 'jotai';

/**
 * Whether the Wireframes view is offered: Finance admins, while the headcount
 * input flag is on. Only a convenience; the report endpoint checks Finance
 * access itself.
 */
export const useCanViewWireframes = () => {
  const {isWorkstreamHeadcountInputEnabled} = useAtomValue(growthbookCacheAtom);
  const pulseUser = useAtomValue(pulseUserAtom);
  return isWorkstreamHeadcountInputEnabled && isFinanceAdmin(pulseUser);
};
